import { Component } from '@angular/core';

@Component({
    template: `<div  refreshover style="height:800px; width:100%; background-color:blue;">Prueba</div>`
  })

  export class RefreshHoverComponent {
  }
